module.exports = __webpack_public_path__ + "img/674-9bfe54.png";